export function trimValidate(message) {
    return (rule, value, callback) => {
        callback(
            (typeof value === "string" && value.trim() === "") || value === null ? new Error(message) : callback()
        );
    };
}
